var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("label", [_vm._v(_vm._s(_vm.$t("survey.group.surveysFromGroups")))]),
      _vm._v(" "),
      _c("vSelect", {
        attrs: {
          options: _vm.groupsForVSelect,
          label: "label",
          reduce: e => e.group,
          multiple: true,
          selectable: () => _vm.selectedGroups.length < _vm.maxGroups,
          clearable: true,
          appendToBody: true,
          "calculate-position": _vm.vSelectInModalWithPopper
        },
        model: {
          value: _vm.selectedGroups,
          callback: function($$v) {
            _vm.selectedGroups = $$v
          },
          expression: "selectedGroups"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }